import H6 from "@/components/ui/headings/H6";
import Paragraph from "@/components/ui/paragraph";
import { processFilesToMediaObjects } from "@/utils/helpers";
import { useTranslations } from "@/lib/static-intl";
import { useCallback } from "react";
import DropzoneImgUploader from "./dropzone-img-uploader";

const ImgUploader = ({ setNoteDetails }) => {
  const t = useTranslations("creator_service.create_note_media_upload");

  const handleDrop = useCallback((acceptedFiles) => {
    const newFiles = processFilesToMediaObjects(acceptedFiles.slice(0, 18)); // Limit to 18
    setNoteDetails((prev) => ({
      ...prev,
      media: [...(prev?.media || []), ...newFiles],
    }));
  }, []);

  const operation = [
    {
      title: "Image size",
      description: "img_size_desc",
    },
    {
      title: "Image Format",
      description: "img_format_desc",
    },
    {
      title: "Image resolution",
      description: "img_resolution_desc",
    },
  ];

  return (
    <div className="w-full md:h-full flex flex-col md:flex-row gap-2 md:gap-8 items-center justify-center dark:bg-brown rounded-lg bg-white px-5 md:px-8">
      <DropzoneImgUploader
        className="min-h-72 md:min-h-[60vh]"
        thumbnail
        multiple
        name="files"
        onDrop={handleDrop}
        files={[]}
      />
      <div className="w-full min-h-72 md:min-h-[65vh] py-2 flex flex-col gap-5 md:gap-8 justify-center pb-16 md:pb-0">
        {operation?.map((item, ind) => (
          <div
            key={ind}
            className="w-full flex justify-center items-center flex-col border dark:border-brown border-gray-200 px-12 py-8 rounded md:rounded-lg"
          >
            <H6 className="text-center !font-semibold">{t(item?.title)}</H6>
            <Paragraph className="text-center !text-xs">
              {t(item?.description)}
            </Paragraph>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImgUploader;
